import {
  createNamespacedHelpers,
} from 'vuex'
const analyte = createNamespacedHelpers('analyte')
const authenticate = createNamespacedHelpers('authenticate')

export default {
  mounted() {
    if (!this.tenantAnalyteList || !this.tenantAnalyteList.length) {
      this.fetchTenantAnalyteList()
    }
  },
  computed: {
    ...authenticate.mapGetters(['currentUserGroup']),
  },
  watch: {
    currentUserGroup() {
      this.fetchTenantAnalyteList()
    },
  },
  methods: {
    ...analyte.mapActions(['getTenantAnalyteList']),
    async fetchTenantAnalyteList() {
      if (this.currentUserGroup.id) {
        await this.getTenantAnalyteList(this.currentUserGroup.id)
      }
    },
  },
}